import * as PIXI from 'pixi.js';
import { GameAssets } from 'src/shared/util/GameAssets';

export class Multiplier extends PIXI.Container {
    private multiplierText: PIXI.BitmapText;
    private sprite: PIXI.Sprite;
    private multiplier: number = 1;

    constructor() {
        super(); // Call the PIXI.Container constructor

        this.sprite = new PIXI.Sprite(GameAssets.textures.gameAtlas.textures["totalMultiplier.webp"]);
        this.sprite.anchor.set(0.5);
        this.sprite.scale.set(0.4);
        this.sprite.position.set(0, 0);
        // Create gradient fill
        const fill = new PIXI.FillGradient({
            type: 'linear',
            start: { x: 0, y: 0 },  // Start at top
            end: { x: 0, y: 1 },    // End at bottom
            colorStops: [
                { offset: 0, color: 0xffffda },
                { offset: 1, color: 0xe7ac3f }
            ],
            // Use normalized coordinate system where (0,0) is the top-left and (1,1) is the bottom-right of the shape
            textureSpace: 'local'
        });
        // Initialize the PIXI.Text object
        this.multiplierText = new PIXI.BitmapText({
            text: '',
            style: {
                fontSize: 60,
                fontFamily: "multiplierFont",
            }
        });
        this.multiplierText.anchor.set(0.5);

        // Add the multiplierText as a child of this container
        this.addChild(this.sprite);
        this.addChild(this.multiplierText);
    }

    // Method to set the initial amount of multipliers
    public setMultiplier(amount: number): void {
        this.multiplier = amount;
        this.multiplierText.text = `x${this.multiplier}`;
    }
}
